<template>
  <div class="main">
    <topInfo title="我发起的" :name="name"></topInfo>
    <search ref="search" type-value="sponsor" :show-status="true" @refreshList="search" @select="selectSearch"
            @selectStatus="selectStatus"></search>
    <!--    <van-pull-refresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">-->
    <div class="content" ref="targetElement" style="overflow: auto;" @scroll="handleScroll">
      <div :style="{ height: scrollHeight + 'px' }">
        <van-pull-refresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh">
          <van-list v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    :error.sync="error"
                    error-text="请求失败，点击重新加载"
                    @load="onLoad">
            <div class="content-item" v-for="(item, index) in dataList" :key="index" @click="jump(item)">
              <div class="content-item-user">
                <div class="avatar">
                  <span id="avatarText">{{ sliceName(item.createName) }}</span>
                </div>
                <div class="content-item-user-name">{{ item.createName }}</div>
              </div>
              <div class="content-item-center">
                <div class="content-item-center-title">
                  {{ item.name.replace(/[_＿\-\s](总公司|常州公司|常州子公司|无锡公司|无锡子公司)/g, '') }}
                </div>
                <div class="content-item-center-content">
                  {{ item.title }}
                </div>
                <div class="content-item-center-tips">
                  <div class="content-item-center-tips-status">
                    <div class="done" :class="getClassForStatus(item.flowState)">{{ item.flowState }}</div>
                    <div style="width: 140px; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">【<span
                        style="width: 140px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ item.taskName }}</span>】
                    </div>
                  </div>
                  <div class="content-item-right">
                    <div class="content-item-right-date">
                      {{ item.createDate.slice(0, 10) }}
                    </div>
                    <div style="font-size: 14px; margin-top: 5px">
                      {{ item.createDate.slice(10) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <!--    </van-pull-refresh>-->

  </div>
</template>

<script>
import search from "../../../components/search/search";
import topInfo from "../../../components/topInfo/topInfo";
import FlowSettingService from "../../../api/sys/flowSettingService";
import Vue from "vue";

export default {
  name: "sponsor",
  data() {
    return {
      value: "",
      category: '',
      businessTable: '',
      businessName: '',
      isLoading: false,
      flowSettingService: null,
      dataList: [],
      current: 0,
      size: 10,
      total: '',
      loading: false,
      finished: false,
      name: Vue.cookie.get('name'),
      error: false,
      status: '',
      isScroll: false,
      scrollHeight: 0,
    }
  },
  components: {
    search,
    topInfo
  },
  created() {
    this.flowSettingService = new FlowSettingService()
    // this.refreshList()
  },
  mounted() {
    if (localStorage.getItem('scrollSponsorPosition')) {
      this.scrollToPosition()
    }
  },
  methods: {
    handleScroll(event) {
      // 在这里处理滚动事件
      // if (this.size === 10) {
        this.isScroll = true
        localStorage.setItem('scrollSponsorPosition', event.target.scrollTop);
      // }
    },
    scrollToPosition() {
      this.$refs.targetElement.scrollTo({
        top: localStorage.getItem('scrollSponsorPosition'),
        // behavior: 'smooth' // 使用平滑滚动效果
      });
      this.current = Number(localStorage.getItem('SponsorCurrent'))
    },
    onRefresh() {
      this.dataList = []
      this.current = 1
      this.size = 10
      // this.value = ''
      // this.category = ''
      // this.status = ''
      // this.$refs.search.activeId = ''
      // this.$refs.search.value = ''
      // this.$refs.search.searchTitle = '系统分类'
      this.refreshList()
      this.isLoading = false;
    },
    search(value) {
      this.dataList = []
      this.current = 1
      this.size = 10
      this.value = value
      this.refreshList()
      this.isLoading = false;
    },
    onLoad() {
      let current = Number(localStorage.getItem('SponsorCurrent'))
      if(!this.isScroll && current) {
        this.current = 1
        this.size = 10 * current
      } else {
        // console.log(this.current, '滚动后')
        this.current += 1
        this.size = 10
      }
      localStorage.setItem('SponsorSize', this.size)
      localStorage.setItem('SponsorCurrent', this.current)
      // this.current += 1
      // if (this.current >= 2) {
      //   if (!this.finished) {
      if (Vue.cookie.get('sponsorSearchValue')) {
        this.value = Vue.cookie.get('sponsorSearchValue')
        this.$nextTick(()=>{
          this.$refs.search.value = this.value
        })
      }
      if(Vue.cookie.get('searchTitle')) {
        this.$nextTick(()=>{
          this.$refs.search.searchTitle = Vue.cookie.get('searchTitle')
          this.$refs.search.activeId = Vue.cookie.get('searchTitleId')
        })
        this.category = Vue.cookie.get('searchTitle')
      }
      if(localStorage.getItem('businessName')) {
        this.category = localStorage.getItem('category')
        this.businessTable = localStorage.getItem('businessTable')
        this.businessName = localStorage.getItem('businessName')
        this.$nextTick(()=>{
          this.$refs.search.name = this.category || ''
          this.$refs.search.searchTitle = this.businessName || ''
          this.$refs.search.businessName = this.businessName || ''
          this.$refs.search.businessTable = this.businessTable || ''
        })
      }
      this.loading = true
      this.$toast.loading({forbidClick: true, message: '数据加载中', duration: 0})
      this.flowSettingService.queryMyApplyedList({
        current: this.current,
        size: this.size,
        title: this.value,
        status: this.status,
        type: this.category,
        businessTable: this.businessTable,
        businessName: this.businessName
      }).then(({data}) => {
        this.dataList.push(...data.records)
        this.total = data.total
        this.loading = false
        this.finished = this.total / this.size <= this.current
        this.error = false
        this.$toast.clear()
        let size = localStorage.getItem('SponsorSize')
        if(size > 10) {
          this.current = size / 10
          localStorage.setItem('SponsorCurrent', this.current)
        }
        if(!this.isScroll && localStorage.getItem('scrollSponsorPosition')) {
          this.scrollHeight = this.dataList.length * 110
          setTimeout(()=>{
            this.scrollToPosition()
          }, 500)
        } else {
          this.scrollHeight =  this.dataList.length * 110
        }
      }).catch(() => {
        this.loading = false
        this.error = true
        this.current--
        this.$toast.clear()
      })
      //   }
      // }
    },
    refreshList() {
      this.loading = true
      this.$toast.loading({forbidClick: true, message: '数据加载中', duration: 0})
      this.flowSettingService.queryMyApplyedList({
        current: this.current,
        size: this.size,
        title: this.value,
        status: this.status,
        type: this.category,
        businessTable: this.businessTable,
        businessName: this.businessName
      }).then(({data}) => {
        this.dataList = data.records
        this.total = data.total
        this.loading = false
        this.finished = this.total / this.size <= this.current
        this.$toast.clear()
        this.scrollHeight = this.dataList.length * 110
        setTimeout(()=> {
          this.$refs.targetElement.scrollTo({
            top: 0,
            behavior: 'smooth' // 使用平滑滚动效果
          });
        }, 0)
      }).catch(() => {
        this.loading = false
        this.error = true
        this.current--
        this.$toast.clear()
      })
    },
    getClassForStatus(value) {
      switch (value) {
        case '审核中':
          return 'primary';
        case '已审核':
          return 'done';
        case '已终止':
          return 'warn';
        case '作废流程':
          return 'warn';
          // 可以根据需要添加更多的状态
        default:
          return '';
      }
    },
    jump(data) {
      if (!this.show) {
        if(data.isMobile === '0') {
          this.$toast.fail('请使用电脑端查看！')
          return
        }
        if(data.businessTable === 'its_contract') {
          switch (data.formKey) {
            case '/its/contract/ItsContractCustomsAffairFormFlow':
              this.$router.push({
                path: '/ItsContractCustomsAffair',
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'sponsor',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })
              break
            case '/its/contract/ItsContractLaborFlowForm':
              this.$router.push({
                path: '/ItsContractLabor',
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'sponsor',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })
              break
            case '/its/contract/ItsContractAgencyFormFlow':
              this.$router.push({
                path: '/ItsContractAgency',
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'sponsor',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })
              break
            case '/its/contract/ItsContractPurchaseFormFlow':
              this.$router.push({
                path: '/ItsContractPurchase',
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'sponsor',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })
              break
            case '/its/contract/ItsContractCarrierFormFlow':
              this.$router.push({
                path: '/ItsContractCarrier',
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'sponsor',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })
              break
            case '/its/contract/ItsContractRentColdFormFlow':
              this.$router.push({
                path: '/ItsContractRentCold',
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'sponsor',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })
              break
            case '/its/contract/ItsContractRentPackFormFlow':
              this.$router.push({
                path: '/ItsContractRentPack',
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'sponsor',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })
              break
            case '/its/contract/ItsContractCustomsInspectFormFlow':
              this.$router.push({
                path: '/ItsContractCustomsInspect',
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'sponsor',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })

              break
            case '/its/contract/ItsContractCustomsApplyFormFlow':
              this.$router.push({
                path: '/ItsContractCustomsApply',
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'sponsor',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })
              break
            case '/its/contract/ItsContractSalesFormFlow':
              this.$router.push({
                path: '/ItsContractSalesFormFlow',
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'todo',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })
              break
            default :
              this.$router.push({
                path: '/' + data.businessTable,
                query: {
                  id: data.businessId,
                  procInsId: data.procInsId,
                  taskId: data.taskId,
                  taskDefKey: data.taskDefKey,
                  procDefId: data.procDefId,
                  type: 'sponsor',
                  businessTable:data.businessTable,
                  projectType: data.type || ''
                }
              })
          }

          return
        }

        if (data.businessTable !== '') {
          this.$router.push({
            path: '/' + data.businessTable,
            query: {
              id: data.businessId,
              procInsId: data.procInsId,
              taskId: data.taskId,
              taskDefKey: data.taskDefKey,
              procDefId: data.procDefId,
              type: 'sponsor',
              projectType: data.type || ''
            }
          })
        } else {
          this.$toast.fail('当前审批单暂无审批页面');
        }
      }
    },
    changeShow(value) {
      this.show = value
    },
    selectStatus(value) {
      this.status = value
      this.current = 1
      this.refreshList()
    },
    selectSearch(data) {
      this.category = data.name
      this.businessTable = data.businessTable
      this.businessName = data.businessName
      localStorage.setItem('category', data.name)
      localStorage.setItem('businessTable', data.businessTable)
      localStorage.setItem('businessName', data.businessName)
      this.dataList = []
      this.current = 1
      this.size = 10
      this.refreshList()
      this.isLoading = false;
    },
    sliceName(value) {
      if (value.length <= 2) {
        return value
      } else {
        return value.slice(-2)
      }
    }
  }
}
</script>

<style scoped>

.content {
  width: 100%;
  height: calc(100vh - 150px - env(safe-area-inset-bottom));
  margin-top: 100px;
  /*margin-bottom: 65px;*/
}

.content-item {
  width: 100%;
  height: 110px;
  background-color: #fff;
  display: flex;
  border-bottom: 1px solid #ececec;
}

.content-item-user {
  display: flex;
  width: 60px !important;
  height: 100px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.content-item-user-name {
  margin-top: 10px;
  font-size: 14px;
}

.content-item-center {
  flex: 1;
  margin-left: 10px;
  position: relative;
}

.content-item-center-title {
  margin-top: 5px;
  font-size: 16px;
  font-weight: bold;
  max-width: 300px;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏超出容器的部分内容 */
  text-overflow: ellipsis; /* 显示省略号 */
}

.content-item-center-content {
  /*margin-top: 10px;*/
  font-size: 15px;
  /*font-weight: bold;*/
  max-width: 300px;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏超出容器的部分内容 */
  text-overflow: ellipsis; /* 显示省略号 */
}

.content-item-center-tips {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
}

.content-item-center-tips-status {
  font-size: 14px;
  margin-top: 5px;
  width: 200px;
  /*white-space: nowrap;*/
  display: flex;
  /*color: #BD3124;*/
}

.content-item-center-tips-current {
  font-size: 14px;
  font-weight: bold;
  margin-left: 10px;
  margin-top: 5px;
}

.done {
  color: #53960A
}

.doing {
  color: #4095E5;
}

.content-item-center-tips-days {
  font-size: 14px;
  width: 80px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  margin-top: 5px;
  margin-left: 15px;
  border: 1px solid #000;
  border-radius: 20px;
}

.content-item-right {
  width: 100px;
  display: flex;
  flex-direction: column;
  /*justify-content: center;*/
  align-items: center;
  margin-right: 20px;
}

.content-item-right-date {
  /*margin-top: 30px;*/
  font-size: 15px;
}

.content-item-right-status {
  margin-top: 15px;
  color: #53960A;
}

.primary {
  color: #5d94f8;
}

.warn {
  color: #BD3124;
}

.avatar {
  width: 50px;
  height: 50px;
  background-color: #0093FF; /* 默认背景色 */
  border-radius: 50%; /* 圆角效果 */
  display: flex;
  align-items: center;
  justify-content: center;
}

#avatarText {
  font-size: 18px;
  color: #fff; /* 文字颜色 */
}

</style>
